import { useState } from 'react'

import type {
  MediaPage,
  ModalItem,
  NotificationConfiguration,
} from '../../types/domain.d'
import * as a9 from '../../analytics'
import { NavigationItem, NotificationType } from '../../types/model'
import { BottomNavigation } from '../components'
import useReadingBar from './useReadingBar'
import Context from './Context'
import Coverage from './Coverage'
import Summary from './Summary'
import Search from './Search'

interface BannerParams extends a9.BaseParams {
  name: NotificationType
}

interface CloseModalParams extends a9.BaseParams {
  view: ModalItem
}

interface ReadingBarProps {
  page: MediaPage
  isFavorited: boolean
  notification?: NotificationConfiguration
}

const ReadingBar = ({
  page,
  isFavorited: initialIsFavorited,
  notification,
}: ReadingBarProps) => {
  const [modalItem, setModalItem] = useState<ModalItem | undefined>()

  const closeModal = () => {
    a9.dispatchEvent(a9.Event.CLOSE_MODAL, {
      view: modalItem,
    } as CloseModalParams)

    setModalItem(undefined)
  }

  const {
    actions,
    handleClickNavItem,
    pageSummary,
    pageCoverage,
    pageContext,
  } = useReadingBar(page, initialIsFavorited, setModalItem)

  const handleCloseBanner = (notificationName: NotificationType) => {
    a9.dispatchEvent(a9.Event.CLOSE_BANNER, {
      name: notificationName,
    } as BannerParams)
  }
  const handleShowBanner = (notificationName: NotificationType) => {
    a9.dispatchEvent(a9.Event.SHOW_BANNER, {
      name: notificationName,
    } as BannerParams)
  }

  return (
    <>
      <Search
        open={modalItem === NavigationItem.Search}
        onClose={closeModal}
        mediaProviderId={page.mediaProviderId}
      />
      <Summary
        open={modalItem === NavigationItem.Summary}
        onClose={closeModal}
        title={page.title}
        {...pageSummary}
      />
      <Coverage
        open={modalItem === NavigationItem.Coverage}
        onClose={closeModal}
        title={page.title}
        {...pageCoverage}
      />
      <Context
        open={modalItem === NavigationItem.Context}
        onClose={closeModal}
        title={page.title}
        {...pageContext}
      />
      <BottomNavigation
        banner={notification}
        onClickBanner={handleCloseBanner}
        onShowBanner={handleShowBanner}
        actions={actions}
        activeItem={modalItem}
        onClickNavItem={handleClickNavItem}
      />
    </>
  )
}

export default ReadingBar
